import { render, staticRenderFns } from "./QAP.vue?vue&type=template&id=0b5689c2"
import script from "./QAP.vue?vue&type=script&lang=js"
export * from "./QAP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports